import { createAction, props } from '@ngrx/store';
import { ApplicationDetails } from '../../models/application-details';

// Load Application Details
const loadApplicationDetails = createAction(
  '[Application Details] Load',
  props<{ projectId: string }>()
);

// Load Success
const loadApplicationDetailsSuccess = createAction(
  '[Application Details] Load Success',
  props<{ applicationDetails: ApplicationDetails[] }>()
);

// Load Failure
const loadApplicationDetailsFailure = createAction(
  '[Application Details] Load Failure',
  props<{ error: any }>()
);

// Update Application Details
const updateApplicationDetails = createAction(
  '[Application Details] Update',
  props<{ projectId: string; applicationDetails: ApplicationDetails[] }>()
);

// Update Success
const updateApplicationDetailsSuccess = createAction(
  '[Application Details] Update Success',
  props<{ updatedApplicationDetails: ApplicationDetails[]; }>()
);

// Update Failure
const updateApplicationDetailsFailure = createAction(
  '[Application Details] Update Failure',
  props<{ error: any }>()
);

// Load Application Details
const loadSideNavApplications = createAction(
  '[Side Nav Application Details] Load',
  props<{ projectId: string }>()
);

// Load Success
const loadSideNavApplicationsSuccess = createAction(
  '[Side Nav Application Details] Load Success',
  props<{ sideNavDetails: any }>()
);

// Load Failure
const loadSideNavApplicationsFailure = createAction(
  '[Side Nav Application Details] Load Failure',
  props<{ error: any }>()
);

export const ApplicationDetailsActions = {
  loadApplicationDetails,
  loadApplicationDetailsSuccess,
  loadApplicationDetailsFailure,
  updateApplicationDetails,
  updateApplicationDetailsSuccess,
  updateApplicationDetailsFailure,
  loadSideNavApplications,
  loadSideNavApplicationsSuccess,
  loadSideNavApplicationsFailure
};
